import React from 'react';
import InventoryPage from './InventoryPage';
import InventoryPageMobile from './InventoryPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const InventoryPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <InventoryPageMobile /> : <InventoryPage />;
};

export default InventoryPageWrapper; 